import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Inject, OnInit, Optional, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { stopAndPreventEvent } from '@utils/dom/event';
import { MirIcon } from '@widgets/mir-icon';
import { WizardPanelCommentItemActionEvent } from '@wizard/wizard-panel/events';
import { WIZARD_PANEL_LIST_ITEM_EDITOR_DATA, WizardPanelListItemEditorData } from './wizard-panel-list-item-editor-overlay.service';

@UntilDestroy()
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mir-wizard-panel-list-item-editor',
  templateUrl: './wizard-panel-list-item-editor.component.html',
  styleUrls: ['./wizard-panel-list-item-editor.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MirIcon,
  ]
})
export class WizardPanelListItemEditorComponent implements OnInit {

  @HostBinding('class')
  get hostCssClass(): string {
    return `wizard-panel-list-item-editor w-[24rem] bg-white rounded shadow-8`;
  }

  @Output() close = new EventEmitter<WizardPanelListItemEditorData>();

  readonly commentControl = new FormControl<string>('');
  #initialComment: string;
  mode: WizardPanelCommentItemActionEvent = 'Display';
  isEditMode = false;

  constructor(
    @Inject(WIZARD_PANEL_LIST_ITEM_EDITOR_DATA) @Optional() private data: WizardPanelListItemEditorData
  ) {
    this.#initialComment = this.data.comment;
    this.mode = this.data.mode;
    this.isEditMode = this.mode === 'Edit';
  }

  get comment(): string { return this.data.comment; }
  get title(): string { return `Wizard.Panel.Comments.Titles.${this.mode}`; }

  ngOnInit() {
    this.commentControl.patchValue(this.#initialComment, { emitEvent: false });
  }

  handleCancel(event: Event) {
    stopAndPreventEvent(event);
    this.close.emit();
  }

  handleValidateAndClose(event: Event) {
    stopAndPreventEvent(event);
    this.close.emit(
      this.isEditMode
        ? { comment: this.commentControl.value, mode: this.mode }
        : null
    );
  }
}
